export default __webpack_public_path__ + "directory-bdm-500-920a4df458e5d45811cbbe5f894dbe0d.png";